import List from './List';
import Show from './Show';
import KYC from './KYC';

export default {
  List,
  KYC,
  Show
};
